<template>
    <div class="wrapper-div">
        <div>
            <div class="appointment-date-modal-wrapper" v-for="i in 5" :key="i">
                <p>
                    <BaseIcon
                        name="clock"
                        size="1x"
                        style="display:inline !important;"
                    >
                    </BaseIcon>
                    14:30 - 14:45
                </p>
                <p>
                    <BaseIcon
                        name="map-marker-alt"
                        size="1x"
                        style="display:inline !important;"
                    >
                    </BaseIcon>
                    Cass City Campus, Building 1 Floor 2 Room 204
                </p>
                <hr />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'AppointmentsDateDialog',

    props: {},

    data() {
        return {};
    },

    computed: {},

    methods: {
        closeDialog() {
            this.$interfaces.dialogModal.getState().resolver.res();
        },
    },

    mounted() {},

    watch: {},
};
</script>

<style lang="css" scoped>
.wrapper-div {
    width: 100%;
    height: 100%;
    overflow-y: scroll;
    overflow-x: hidden;
}
</style>
